"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _hls = _interopRequireDefault(require("hls.js"));

var _HlsLoader = _interopRequireDefault(require("./loader/HlsLoader"));

function createHlsStream(fragments, startPosition, streamLevel, sourceUrl, videoRef) {
  var hls = new _hls["default"]({
    loader: _HlsLoader["default"],
    fragments: fragments,
    startPosition: startPosition,
    startLevel: streamLevel,
    capLevelToPlayerSize: true,
    enableWorker: true
  });
  hls.loadSource(sourceUrl);

  try {
    hls.attachMedia(videoRef);
  } catch (error) {
    if (error.name === 'AbortError') {
      // Silently ignore AbortError where user pressed spacebar quickly,
      // leave other errors - they should be investigated.
      // See HUB-1872, HUB-1897 &
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
      return hls;
    }

    throw error;
  }

  return hls;
}

module.exports = createHlsStream;